import Flex from "../../components/Flex"
import Screen from "./components/Screen"
import { spacing } from "./styles"

import "./WebHosting.scss"
import Button from "./components/Button"
import { useNavigate } from "react-router-dom"
import datasource from "../../datasource"
import MobileIcon from "../../components/MobileIcon"

interface Capability {
    title: string
    description: string
}

interface Partner {
    slug: string
    name: string
    practice: string
    tagline: string
    url: string
    mobileIcon: React.JSX.Element
}

const {
    pageTitle,
    pageSubTitle,
    heroCtaLabel,
    pitch,
    highlight,
    capabilities,
    partners,
    welcomeTitle,
    welcomeSubTitle,
    welcomeBtnLabel
} = datasource.webhosting

export default () => {

    const navigate = useNavigate()

    const goToContactUs = () => {
        navigate("/")
        setTimeout(() => {
            document.scrollingElement?.scrollTo({ top: window.innerHeight, behavior: "smooth" })
        }, 100)
    }

    return (
        <div className="mb-webhosting">
            <Screen className="mb-webhosting__title-screen">
                <Flex vertical gap={spacing("xl")}>
                    <MobileIcon.WebHosting width={46} height={46}></MobileIcon.WebHosting>
                    <div className="mb-webhosting__title">{pageTitle}</div>
                    <div className="mb-webhosting__subTitle">{pageSubTitle}</div>
                    <Button onClick={goToContactUs}>
                        <Flex gap={spacing("md")} reposive={false} align="center" justify="center">
                            {heroCtaLabel}
                            <MobileIcon.ArrowUp width={20} height={20}></MobileIcon.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </Screen>

            <Screen className="mb-webhosting__pitch-screen">
                <Flex vertical gap={spacing("lg")} className="mb-webhosting__panel">
                    <div className="mb-webhosting__section-title">{pitch.title}</div>
                    {pitch.paragraphs.map((paragraph, i) => (
                        <div key={i} className="mb-webhosting__pitch__text">{paragraph}</div>
                    ))}
                </Flex>
            </Screen>

            <Screen className="mb-webhosting__highlight-screen">
                <Flex vertical gap={spacing("lg")} className="mb-webhosting__highlight">
                    <div className="mb-webhosting__highlight__eyebrow">{highlight.eyebrow}</div>
                    <div className="mb-webhosting__highlight__title">{highlight.title}</div>
                    <div className="mb-webhosting__highlight__description">{highlight.description}</div>
                    <Flex vertical gap={spacing("md")} className="mb-webhosting__highlight__examples">
                        {highlight.examples.map(example => (
                            <div key={example} className="mb-webhosting__highlight__example">&ldquo;{example}&rdquo;</div>
                        ))}
                    </Flex>
                    <Flex vertical gap={spacing("md")}>
                        {highlight.points.map(point => (
                            <div key={point} className="mb-webhosting__highlight__point">{point}</div>
                        ))}
                    </Flex>
                </Flex>
            </Screen>

            <Screen className="mb-webhosting__capabilities-screen">
                <Flex vertical gap={spacing("md")} className="mb-webhosting__section-head">
                    <div className="mb-webhosting__section-title">{capabilities.title}</div>
                    <div className="mb-webhosting__section-subTitle">{capabilities.subTitle}</div>
                </Flex>
                <Flex vertical gap={spacing("lg")} className="mb-webhosting__capabilities">
                    {(capabilities.items as Capability[]).map(capability => (
                        <Flex vertical gap={spacing("md")} key={capability.title} className="mb-capability-card">
                            <div className="mb-capability-card__title">{capability.title}</div>
                            <div className="mb-capability-card__description">{capability.description}</div>
                        </Flex>
                    ))}
                </Flex>
            </Screen>

            <Screen className="mb-webhosting__partners-screen">
                <Flex vertical gap={spacing("md")} className="mb-webhosting__section-head">
                    <div className="mb-webhosting__section-title">{partners.title}</div>
                    <div className="mb-webhosting__section-subTitle">{partners.subTitle}</div>
                </Flex>
                <Flex vertical gap={spacing("lg")} className="mb-webhosting__partners">
                    {(partners.items as Partner[]).map(partner => (
                        <a
                            key={partner.slug}
                            className="mb-partner-card"
                            href={partner.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Flex vertical align="center" gap={spacing("md")}>
                                <Flex align="center" justify="center" className="mb-partner-card__logo">
                                    {partner.mobileIcon}
                                </Flex>
                                <div className="mb-partner-card__name">{partner.name}</div>
                                <div className="mb-partner-card__practice">{partner.practice}</div>
                                {partner.tagline ? <div className="mb-partner-card__tagline">{partner.tagline}</div> : null}
                                <Flex align="center" gap={spacing("md")} reposive={false} className="mb-partner-card__link">
                                    {partners.linkLabel}
                                    <MobileIcon.ArrowUp width={16} height={16}></MobileIcon.ArrowUp>
                                </Flex>
                            </Flex>
                        </a>
                    ))}
                </Flex>
            </Screen>

            <div className="mb-webhosting__welcome-box">
                <Flex vertical gap={spacing("lg")} className="mb-webhosting__welcome">
                    <div className="mb-webhosting__welcome__title">{welcomeTitle}</div>
                    <div className="mb-webhosting__welcome__subTitle">{welcomeSubTitle}</div>
                    <Button onClick={goToContactUs}>
                        <Flex gap={spacing("md")} reposive={false} align="center" justify="center">
                            {welcomeBtnLabel}
                            <MobileIcon.ArrowUp width={20} height={20}></MobileIcon.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </div>
        </div>
    )
}
